import { Dialog } from "@headlessui/react";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useRowPagination } from "hooks/useRowPagination";

import RowPagination from "components/General/RowPagination";
import DialogBackdrop from "components/ModalDialogs/DialogBackdrop";
import SimpleDataRow from "components/General/SimpleDataRow";
import FormInputError from "components/General/FormInputError";
import config from "config/config";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { AgentData } from "context/Agent/DataProvider";

export const PolicyLookUpWithSearchResultsModel = ({
  isOpenPolicyLookup,
  setIsOpenPolicyLookup,
  setValue,
  setSelectedPolicyId,
}) => {
  let navigate = useNavigate();
  const { agentPolicies: policies } = useContext(AgentData);
  const [keyword, setKeyword] = useState();
  const [searchResults, setSearchResults] = useState([]);
  const [policyId, setPolicyId] = useState();
  const [amount, setAmount] = useState();
  const [oldPolicyId, setOldPolicyId] = useState();
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    reset();
    setSearchResults(policies);
  }, [policies]);
  useEffect(() => {
    if (policyId) {
      setValue("policyNumber", oldPolicyId);
      setValue("amount", amount);
      setSelectedPolicyId(policyId);
    }
    setIsOpenPolicyLookup(false);
  }, [policyId]);
  const searchPolicy = () => {
    setKeyword(document.getElementById("id_policyLookupInput").value);
    if (document.getElementById("id_policyLookupInput").value) {
      let policyList = [];
      policies.forEach((policy) => {
        if (
          policy.oldPolicy
            ?.toLowerCase()
            .startsWith(
              document
                .getElementById("id_policyLookupInput")
                .value?.toLowerCase()
            )
        ) {
          policyList.push(policy);
        } else {
          let party = policy?.parties?.filter((p) =>
            p.person?.fullName
              ?.toLowerCase()
              ?.startsWith(
                document
                  .getElementById("id_policyLookupInput")
                  .value?.toLowerCase()
              )
          );
          if (party?.length) {
            policyList.push(policy);
          }
        }
      });
      setSearchResults(policyList);
    }
  };

  const { rowsForDisplay: current, rowPaginationProps } =
    useRowPagination(searchResults);

  return (
    <>
      <Dialog
        open={isOpenPolicyLookup}
        onClose={() => setIsOpenPolicyLookup(false)}
        className="ui-dialogs"
      >
        {/* The backdrop, rendered as a fixed sibling to the panel container */}
        <DialogBackdrop />
        {/* Full-screen container to center the panel */}
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel
            role="dialog"
            aria-modal="true"
            className={`ui-default-dialog ${
              searchResults?.length > 5 ? "h-[90%]" : ""
            }`}
          >
            <Dialog.Title className="font-body text-xl font-bold text-left">
              {t("AgentPolicyLookUpWithSearchResultsModel-contractlookup")}
            </Dialog.Title>
            {config.ENABLE_ALLOWED_CC_PAYMENT_BY_POLICY_TYPES === "true" && (
              <div className="text-xs text-theme-text-secondary mt-4">
                {t("AgentPolicyLookUpWithSearchResultsModel-Note")}
              </div>
            )}
            <button
              className="ui-default-dialog-close"
              aria-label="close Contract Look-Up window"
              onClick={() => setIsOpenPolicyLookup(false)}
            >
              <svg
                className="ui-icon h-3.5 w-3.5"
                focusable="false"
                aria-hidden="true"
                role="presentation"
              >
                <use href="#ui-icon-close"></use>
              </svg>
            </button>
            <hr />
            <Dialog.Description>
              <span className="sr-only">
                {t("AgentPolicyLookUpWithSearchResultsModel-FindPolicy")}
              </span>
            </Dialog.Description>
            <form className="flex flex-col sm:flex-row">
              <div className="flex flex-col flex-grow justify-start sm:mr-4">
                <div className="relative">
                  <input
                    id="id_policyLookupInput"
                    className="border border-ui-gray-medium h-9 w-full p-2 pl-8 rounded"
                    aria-label="Site Search"
                    placeholder={t(
                      "AgentPolicyLookUpWithSearchResultsModel-entercontarct-or-name"
                    )}
                    {...register("keyword", {
                      required: t(
                        "AgentPolicyLookUpWithSearchResultsModel-entername-beforecontinue"
                      ),
                    })}
                  />
                  <svg
                    className="ui-icon w-4 h-4 absolute text-theme-action left-0 top-1/2 mt-[-.5rem] ml-2"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-search"></use>
                  </svg>
                </div>
                <FormInputError
                  id="id_policyLookupError"
                  errorMessage={errors?.keyword?.message}
                />
              </div>
              <div>
                <button
                  type="button"
                  id="id_policyLookupBtn"
                  className="ui-btn-primary h-9 w-32 mx-auto ui-btn-min-w mt-4 sm:mt-0"
                  onClick={() => searchPolicy()}
                >
                  {t("AgentPolicyLookUpWithSearchResultsModel-Search")}
                </button>
              </div>
            </form>
            {current.length > 0 &&
              current.map((searchResult, idx) => {
                return (
                  <SimpleDataRow
                    key={`agent-policy-lookup-${searchResult.category} - ${idx}`}
                    type="policylookup"
                    data={searchResult}
                    setPolicyId={setPolicyId}
                    setAmount={setAmount}
                    setOldPolicyId={setOldPolicyId}
                  />
                );
              })}
            {current.length === 0 && getValues("keyword") && (
              <FormInputError
                id="id_policyLookupError"
                errorMessage={"Policy not found, try again"}
              />
            )}
            {current.length > 1 && (
              <div className="flex justify-between items-start mt-6">
                <div></div>
                <RowPagination {...rowPaginationProps} />
              </div>
            )}
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
};
